// extracted by mini-css-extract-plugin
export default {"p_tye":"f95b4921aa","slcted":"_29c8a807f5","slc_color":"f1afb14cb6","item_p":"_6b6eea508d","r0":"e577806902"};